import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id CA8684F7-5654-4AE0-9840-9C3AD9611D19
 * name arrow-down-bold
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowDownBoldIcon = createSvgIcon(<><path d="M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z" /></>, 'ArrowDownBoldIcon');
export default ArrowDownBoldIcon